import styled from 'styled-components';

export const EditorControlButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  > button {
    margin-top: 10px;
    margin-right: 10px !important;
    height: 40px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorControls/index.jsx